const imageZheng = 'https://oss.turingsenseai.com/15940928277274.png'
const imageFan = 'https://oss.turingsenseai.com/1607656223555574582.png'
const imageZuo = 'https://oss.turingsenseai.com/1607656276530347101.png'
const imageYou = 'https://oss.turingsenseai.com/1607656495413601055.png'
const imageDi = 'https://oss.turingsenseai.com/1607656530167057945.png'
const imageLi = 'https://oss.turingsenseai.com/15940929036333.png'
const content = `
<p class="ql-align-center">
</p>
<p class="ql-align-justify">
  温馨提示：在上传商品前您需仔细阅读并按照商品拍摄规范要求上传商品图片，请
  <strong style="color: rgb(237, 125, 49);">
    拍摄实物（对屏对图拍摄无效），禁止拼图，请勿遗漏瑕疵处。
  </strong>
  完整的图片有助于商品
  <strong style="color: rgb(237, 125, 49);">
    准确估价
  </strong>
  哦~
</p>
<p class="ql-align-justify">
  <br>
</p>
<p class="ql-align-justify">
  <strong>
    1.&nbsp;正面（必拍）
  </strong>
</p>
<p class="ql-align-justify">
  将包包置于无杂物的背景中，完整拍摄包包的正面。确保无遮挡、无反光、光线充足、包包居于画面中央。
</p>
<p class="ql-align-center">
  <img class="custom-image" src="${imageZheng}">
</p>
<p class="ql-align-justify">
  <strong>
    2.&nbsp;反面（必拍）
  </strong>
</p>
<p class="ql-align-justify">
  请完整拍摄包包的反面。
</p>
<p class="ql-align-center">
  <img class="custom-image" src="${imageFan}">
</p>
<p class="ql-align-justify">
  <strong>
    3.&nbsp;底面（必拍）
  </strong>
</p>
<p class="ql-align-justify">
  请完整拍摄包包的底面；
</p>
<p class="ql-align-center">
  <img class="custom-image" src="${imageDi}">
</p>
<p class="ql-align-justify">
  <br>
</p>
<p class="ql-align-justify">
  <strong>
    4.&nbsp;左侧面（必拍）
  </strong>
</p>
<p class="ql-align-justify">
  请完整拍摄包包的左侧面；
</p>
<p class="ql-align-center">
  <img class="custom-image" src="${imageZuo}">
</p>
<p class="ql-align-center">
  <br>
</p>
<p class="ql-align-justify">
  <strong>
    5.&nbsp;右侧面（必拍）
  </strong>
</p>
<p class="ql-align-justify">
  请完整拍摄包包右侧面；
</p>
<p class="ql-align-center">
<img class="custom-image" src="${imageYou}">
</p>
<p class="ql-align-justify">
  <br>
</p>
<p class="ql-align-justify">
  <strong>
    6.&nbsp;内里（必拍）
  </strong>
</p>
<p class="ql-align-justify">
  请将包撑开，清晰完整拍摄包包内里；
</p>
<p class="ql-align-center">
<img class="custom-image" src="${imageLi}">
</p>
<p>
  <br>
</p>
`
export default {
  content,
  title: '人工估价商品拍摄规范'
}
